<!--
 * @Author: cn1994
 * @Date: 2023-02-28 11:36:56
 * @LastEditors: cn1994
 * @LastEditTime: 2025-01-14 18:01:17
 * @Description: 弹窗组件封装
-->
<template>
  <el-dialog
    :title="title"
    :visible.sync="customDialogShow"
    :width="getWidth"
    :close-on-click-modal="false"
    class="ls-custom-dialog-component"
    :show-close="hasCloseIcon"
    :append-to-body="appendToBody"
    :custom-class="customClass"
    @close="cancel"
    v-dialog-close="overlayClose ? cancel : false"
  >
    <div class="ls-custom-dialog-component-content">
      <slot name="content">默认内容</slot>
    </div>
    <slot name="footer">
      <div class="dialog-footer" v-if="hasCancelBtn || hasCancelOk">
        <el-button size="small" @click="cancel" v-if="hasCancelBtn">{{
          cancelText
        }}</el-button>
        <el-button
          size="small"
          type="primary"
          @click="confirm"
          :disabled="disabled"
          :loading="confirmLoading"
          v-if="hasCancelOk"
          >{{ confirmText }}</el-button
        >
      </div>
    </slot>
  </el-dialog>
</template>

<script>
export default {
  props: {
    title: {
      // 标题
      type: String,
      default: "提示",
    },
    visible: {
      type: Boolean,
      default: false,
    },
    hasCancelBtn: {
      //是否显示取消按钮
      type: Boolean,
      default: true,
    },
    hasCancelOk: {
      //是否显示确定按钮
      type: Boolean,
      default: true,
    },
    confirmText: {
      //确定按钮文案
      type: String,
      default: "确定",
    },
    cancelText: {
      //取消按钮文案
      type: String,
      default: "取消",
    },
    hasCloseIcon: {
      //是否显示关闭按钮
      type: Boolean,
      default: true,
    },
    confirmLoading: {
      //确定按钮是否有loading
      type: Boolean,
      default: false,
    },
    overlayClose: {
      //是否点遮罩层关闭
      type: Boolean,
      default: true,
    },
    disabled:{
      //是否禁用确定按钮
      type: Boolean,
      default: false,
    },
    // Dialog 自身是否插入至 body 元素上。嵌套的 Dialog 必须指定该属性并赋值为 true
    appendToBody: {
      type: Boolean,
      default: true,
    },
    width: {
      // 宽度
      type: [String, Number],
      default: "660",
    },
    // 自定义dialog类名
    customClass: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      // customDialogShow: false,
    };
  },
  computed: {
    customDialogShow: {
      get() {
        return this.visible;
      },
      set(v) {
        this.$emit("update:visible", v);
      },
    },
    getWidth(){
      if (typeof this.width === 'number') {
        return this.width
      }

      if (typeof this.width === 'string' && this.width.includes('%')) {
        return this.width
      } else {
        return this.width + 'px'
      }
    }
  },

  methods: {
    confirm(e) {
      this.$emit("confirm");
    },
    cancel(e) {
      this.$emit("cancel");
    },
  },
};
</script>

<style lang="less" scoped>
.ls-custom-dialog-component {
  /deep/ .el-dialog {
    display: flex;
    flex-direction: column;
    border-radius: 4px;
    border-top: 1px solid #007aff;
    .el-dialog__header {
      background-color: #007aff;
      border-radius: 4px 4px 0 0;
      padding: 8px 0;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      .el-dialog__title {
        font-size: 14px;
        color: #fff;
      }
      .el-dialog__headerbtn {
        top: 10px;
        right: 13px;
        .el-dialog__close {
          color: #fff;
        }
      }
    }
    .el-dialog__body {
      padding: 20px;
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      .ls-custom-dialog-component-content {
        flex: 1;
        display: flex;
        overflow: hidden;
        flex-direction: column;
      }
    }
    .dialog-footer {
      margin-top: 20px;
      text-align: center;
    }
  }
}
.dialog-footer {
  /deep/ .el-button {
    min-width: 74px;
  }
}
</style>